import {Component} from '@angular/core';

@Component({
  selector: 'mc-drawer-title',
  templateUrl: './drawer-title.component.html',
  styleUrls: ['./drawer-title.component.scss'],
})
export class DrawerTitleComponent {}
